import React from "react";
import PolicyLayout from "../../components/PolicyLayout";
import { Highlight } from "../HomePage";

const Cancellation = () => {
  return (
    <PolicyLayout title={<>Cancellation <Highlight tone="dark">Policy</Highlight></>}>
      <i style={{ fontSize: 14 }}>Last updated on Jan 29th 2025</i>
      <p>
        <strong>ANJ BUSINESS SOLUTIONS PRIVATE LIMITED</strong>{" "}
        believes in helping its customers as far as possible, and has
        therefore a liberal cancellation policy. Under this policy:
      </p>
      <ul>
        <li>
          1. Cancellations will be considered only if the request is
          made within 15 days of placing the order. However, the
          cancellation request may not be entertained if the orders
          have been communicated to the vendors/merchants and they
          have initiated the process of shipping them.
        </li>
        <li>
          2. ANJ BUSINESS SOLUTIONS PRIVATE LIMITED does not accept
          cancellation requests for orders already initiated or in
          transit or completed. However, refund/replacement can be
          made if the customer establishes that the quality of
          product/service delivered is not good.
        </li>
        <li>
          3. In case of improper delivery of services or inaccurate
          results, please report the same to our Customer Service
          team. The request will, however, be entertained once the
          health provider has checked and determined the same at his
          own end. This should be reported within 15 days of receipt of
          the product/service.
        </li>
        <li>
          4. In case you feel that the product/service received is not
          as promised by us or as per your expectations, you must
          bring it to the notice of our customer service within 15 days
          of receiving the product/service. The Customer Service Team
          after looking into your complaint will take an appropriate
          decision.
        </li>
        <li>
          5. In case of any Refunds approved by the ANJ BUSINESS
          SOLUTIONS PRIVATE LIMITED, it’ll take 6-8 days for the
          refund to be processed to the end customer.
        </li>
      </ul>
    </PolicyLayout>
  );
};

export default Cancellation;
